import { render, staticRenderFns } from "./AlgoliaRefinementListDropdown.vue?vue&type=template&id=0c48fd9a&scoped=true&"
import script from "./AlgoliaRefinementListDropdown.vue?vue&type=script&lang=js&"
export * from "./AlgoliaRefinementListDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AlgoliaRefinementListDropdown.vue?vue&type=style&index=0&id=0c48fd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48fd9a",
  null
  
)

export default component.exports